import { PropsWithChildren } from 'react';
import { NavBar } from './NavBar';

export const Layout = ({ children }: PropsWithChildren) => (
  <div>
    <NavBar />
    <div className="p-2 md:p-16 flex">{children}</div>
  </div>
);
